const WorkPermitPage = () => {
  return <div>Work Permit</div>;
};

export default WorkPermitPage;
